import useLocationQueryParams from "../hooks/useLocationQueryParams";
import useGetActiveOrganizations from "../views/Proactive/Utilities/hooks/useGetActiveOrganizations";
import _ from "lodash";
import {Box} from "@mui/material";
import React from "react";
import LoadingPlaceholderBlock from "../../common/LoadingPlaceholderBlock";
import BasicFilterSelect from "./BasicFilterSelect";

export default function OrganizationFilter({urlParams, setOrganizationId}) {
    const {params, setParams} = useLocationQueryParams();
    const {organizations, loading} = useGetActiveOrganizations();

    const organizationName = organizations?.find((item) => item.id === _.get(urlParams, 'organizationId'))
    const handleOrganizationSelectChange = (event) => {
        setOrganizationId(event?.id)
        const queryParams = {...params, organizationId: event?.id}
        setParams(queryParams);
    }

    return (
        <Box sx={styles.organizationSelectContainer}>
            {loading ?
                <LoadingPlaceholderBlock
                    width={'100%'}
                    height={'45px'}
                    borderRadius={'8px'}
                    backgroundColor={'#E3E2E1'}
                /> :
                <BasicFilterSelect
                    placeholder={'Select organization'}
                    options={organizations}
                    value={organizationName}
                    onChange={handleOrganizationSelectChange}
                    textFieldStyle={styles.organizationSelectInput}
                    listBoxHeight={380}
                />
            }
        </Box>
    )
}

const styles = {
    organizationSelectContainer: {
        width: '250px',
        height: '45px',
        backgroundColor: '#FFFFFF',
        borderRadius: '8px',
        ml: '10px'
    },
    organizationSelectInput : {
        [`& fieldset`]: {
            borderRadius: '8px',
        },
        '& .MuiInputBase-input': {
            height: '12px',
        },
    },
}